import { SecondaryButton, PrimaryButton } from '@entur/button';
import { SearchIcon, ResetIcon, PlayIcon } from '@entur/icons';
import { useIntl } from 'react-intl';
import classnames from 'classnames/bind';
import styles from './styles.module.scss';

interface SearchClearButtonProps {
  searchForm: () => void;
  clearForm?: () => void;
  className?: string;
  run?: boolean;
  loading?: boolean;
}

const SearchClearButton = ({ searchForm, clearForm, className, run, loading }: SearchClearButtonProps) => {
  const intl = useIntl();
  const cx = classnames.bind(styles);

  return (
    <div className={cx(styles.buttonGrid, className)}>
      {clearForm ? (
        <SecondaryButton
          type="button"
          className={styles.buttonSearchClear}
          onClick={clearForm}
          loading={loading}
          disabled={loading}
        >
          <ResetIcon className={styles.iconSC} />
          {intl.formatMessage({ id: 'generalValues.emptyForm' })}
        </SecondaryButton>
      ) : (
        <div className={styles.noClearForm} />
      )}

      <PrimaryButton
        type="submit"
        className={styles.buttonSearchClear}
        onClick={searchForm}
        loading={loading}
        disabled={loading}
      >
        {run ? <PlayIcon className={styles.iconSC} /> : <SearchIcon className={styles.iconSC} />}
        {run ? intl.formatMessage({ id: 'reportTemplates.run' }) : intl.formatMessage({ id: 'generalValues.search' })}
      </PrimaryButton>
    </div>
  );
};

export default SearchClearButton;
